import { gql } from '@apollo/client';

export const GET_RECIPE_ADVICE_IA = gql`
  query GetRecipeAdviceAi(
    $title: String!
    $instructions: String
    $advice: String
    $rawIngredients: String
    $difficulty: String
    $prepTime: Int
    $waitTime: Int
    $cookTime: Int
    $estimatedCost: String
    $calorieLevel: String
  ) {
    getRecipeAdviceAi(
      title: $title
      instructions: $instructions
      advice: $advice
      rawIngredients: $rawIngredients
      difficulty: $difficulty
      prepTime: $prepTime
      waitTime: $waitTime
      cookTime: $cookTime
      estimatedCost: $estimatedCost
      calorieLevel: $calorieLevel
    ) {
      advice
    }
  }
`;
